import React, { useRef, useState, useEffect, PropsWithChildren } from "react";
import { Popup, PopupProps } from "semantic-ui-react";

interface IOverflowTextTooltipProps extends PropsWithChildren<Omit<PopupProps, "trigger" | "content">> {
  wrapperClassName?: string;
  wrapperStyle?: React.CSSProperties;
}

//component to apply a tooltip on overflow
export const OverflowTooltip: React.FC<IOverflowTextTooltipProps> = ({
  children,
  wrapperClassName,
  wrapperStyle,
  mountNode,
  ...props
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (el) {
      setIsOverflowing(el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight);
    }
  }, [children]);

  const content = (
    <div ref={ref} className={wrapperClassName} style={wrapperStyle}>
      {children}
    </div>
  );

  return isOverflowing ? (
    <Popup content={children} trigger={content} mountNode={mountNode || undefined} {...props} />
  ) : (
    content
  );
};
